import styled from 'styled-components';

export const DropdownItem = styled.div`
  width: 100%;
  padding-top: 4px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const DropdownItemTitle = styled.div`
  font: ${(props) => props.theme.fonts.textSmallHeight16};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const DropdownItemSubTitle = styled.div`
  font: ${(props) => props.theme.fonts.textMicroWeight400};
  color: ${(props) => props.theme.colors.greys.dark};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
